function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 11.3721,
  y: 61.1582,
  width: 132.632,
  height: 134.842,
  rx: 5.89473,
  fill: "#D8F1E5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M197.474 26.5791V176.3C197.474 180.244 194.277 183.441 190.334 183.441H9.14062C5.19697 183.441 2 180.244 2 176.3V99.5389C2 95.5953 5.19696 92.3983 9.14061 92.3983H40.8271",
  stroke: "#003311",
  strokeWidth: 2.67773,
  strokeDasharray: "2.68 4.46"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M110.894 183.441H9.14061C5.19696 183.441 2 180.244 2 176.301V99.5391C2 95.5954 5.19696 92.3984 9.14061 92.3984H40.8271",
  stroke: "#003311",
  strokeWidth: 2.67773
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M118.481 178.086H107.771V188.797H118.481V178.086Z",
  fill: "#22EE88",
  stroke: "#003311",
  strokeWidth: 2.67773,
  strokeMiterlimit: 10
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_dd_4867_705)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 31,
  y: 15,
  width: 155,
  height: 155,
  rx: 8,
  fill: "white"
}), /*#__PURE__*/React.createElement("rect", {
  x: 30.1074,
  y: 14.1074,
  width: 156.785,
  height: 156.785,
  rx: 8.89258,
  stroke: "#DDDCDB",
  strokeWidth: 1.78515
}));

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 35,
  y: 19,
  width: 147,
  height: 147,
  rx: 6,
  fill: "#C8FBE1"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M78.7803 139.798V80.8352L62 88.4965V59.7917L97.1378 45.0044H120.423L155.823 59.7917V88.4965L139.048 80.8352V139.798H78.7803Z",
  fill: "#72D0A1"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M120.169 86.9004L111.681 82.7472V66.7603H128.652V82.7472L120.164 86.9004H120.169ZM113.482 81.624L120.169 84.8931L126.855 81.624V68.5621H113.487V81.624H113.482Z",
  fill: "#C8FBE1"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M108.914 51.9914C99.8664 51.9914 95.7289 45.9092 95.5664 45.6655L97.1309 45C97.2743 45.2103 100.875 50.1896 108.918 50.1896V51.9914H108.914Z",
  fill: "#C8FBE1"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M108.914 51.9915V50.1897C116.953 50.1897 120.298 45.222 120.441 45.0117L122.11 45.7239C121.948 45.9677 117.961 51.9915 108.914 51.9915Z",
  fill: "#C8FBE1"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 164,
  width: 50,
  height: 50,
  rx: 8,
  fill: "#003311"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M189.477 9.34131C180.55 9.34131 173.289 16.6026 173.289 25.5288C173.289 34.4551 180.55 41.7163 189.477 41.7163C198.403 41.7163 205.664 34.4551 205.664 25.5288C205.664 16.6026 198.397 9.34131 189.477 9.34131ZM189.477 40.5601C181.186 40.5601 174.445 33.8191 174.445 25.5288C174.445 17.2385 181.186 10.4976 189.477 10.4976C197.767 10.4976 204.508 17.2385 204.508 25.5288C204.508 33.8191 197.767 40.5601 189.477 40.5601Z",
  fill: "#22EE88"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M193.113 19.3372L189.477 22.9736L185.841 19.3372H185.025L183.291 21.0715V21.8867L186.927 25.5231L183.291 29.1595V29.9747L185.025 31.709H185.841L189.477 28.0726L193.113 31.709H193.929L195.663 29.9747V29.1595L192.026 25.5231L195.663 21.8867V21.0715L193.929 19.3372H193.113ZM190.801 25.1184V25.9336L194.437 29.57L193.518 30.4892L189.882 26.8528H189.066L185.43 30.4892L184.511 29.57L188.147 25.9336V25.1184L184.511 21.482L185.43 20.5628L189.066 24.1992H189.882L193.518 20.5628L194.437 21.482L190.801 25.1184Z",
  fill: "#22EE88"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M187.567 21.8085L186.277 20.6796C185.824 20.2834 185.156 20.2583 184.674 20.6192C184.055 21.0841 183.99 21.9902 184.538 22.538L185.642 23.6421C186.668 24.6682 186.668 26.3318 185.642 27.3579L184.538 28.462C183.99 29.0098 184.055 29.9159 184.674 30.3808C185.156 30.7417 185.824 30.7166 186.277 30.3204L187.567 29.1915C188.674 28.223 190.326 28.223 191.433 29.1915L192.702 30.3016C193.151 30.6946 193.828 30.672 194.25 30.25C194.672 29.828 194.695 29.151 194.302 28.7018L193.191 27.4331C192.223 26.3263 192.223 24.6737 193.191 23.5669L194.302 22.2982C194.695 21.849 194.672 21.172 194.25 20.75C193.828 20.328 193.151 20.3054 192.702 20.6984L191.433 21.8085C190.326 22.777 188.674 22.777 187.567 21.8085Z",
  fill: "#22EE88"
});

var _ref16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_dd_4867_705",
  x: 12.0424,
  y: 13.2148,
  width: 183.102,
  height: 183.102,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 3.0665,
  operator: "erode",
  in: "SourceAlpha",
  result: "effect1_dropShadow_4867_705"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 6.13301
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3.0665
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0588235 0 0 0 0 0.0588235 0 0 0 0 0.0588235 0 0 0 0.04 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4867_705"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 3.0665,
  operator: "erode",
  in: "SourceAlpha",
  result: "effect2_dropShadow_4867_705"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -4.9064,
  dy: 12.266
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 7.66626
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0588235 0 0 0 0 0.0588235 0 0 0 0 0.0588235 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_4867_705",
  result: "effect2_dropShadow_4867_705"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect2_dropShadow_4867_705",
  result: "shape"
})));

var SvgProduct = function SvgProduct(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 197,
    viewBox: "0 0 214 197",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProduct, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/product.3e4cacf9.svg";
export { ForwardRef as ReactComponent };